const STORAGE_KEY = "pckia-font-scale";
const ALLOWED = ["1", "1.1", "1.2"];

function applyScale(scale) {
  document.documentElement.style.setProperty("--font-scale", scale);

  document.querySelectorAll("[data-font-scale]").forEach((btn) => {
    btn.setAttribute("aria-pressed", String(btn.dataset.fontScale === scale));
  });
}

function getSavedScale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  return ALLOWED.includes(saved) ? saved : "1";
}

export function initFontSize() {
  applyScale(getSavedScale());

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-font-scale]");
    if (!btn) return;

    const scale = btn.dataset.fontScale;
    if (!ALLOWED.includes(scale)) return;

    localStorage.setItem(STORAGE_KEY, scale);
    applyScale(scale);
  });
}
